<template>
  <div class="modal fade delete-product-current-modal" id="DeleteProductModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Deletar produto</h1>
                  <button type="button" class="btn-close delete-product-current-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formDeleteProduct" v-on:submit="deleteProductMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p>Quer realmente deletar o produto "{{ getCurrentDeleteProduct.name }}" ?</p>
                  <p>Se precisar deste produto no futuro, vai precisar criá-lo novamente</p>
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="password_product_delete" class="form-label fw-medium"
                      >Senha do sistema</label
                    >
                    <input
                      type="password"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="password_product_delete"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiDeleteProduct" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageDeleteProduct">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger delete-product-current-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonDeleteProduct" class="btn btn-dark">Deletar produto</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../../config/axios.js';

export default {
  name: "DeleteProductModal",
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getCurrentDeleteProduct'
    ])
  },
  methods: {
    deleteProductMethod(){
      event.preventDefault();

      console.log("deletando o:", this.getCurrentDeleteProduct);

      if(
        document.getElementById("password_product_delete") == undefined ||
        document.getElementById("password_product_delete").value == ""
      ){
        this.alertResponse("Por favor preencha a senha", true);
        return;
      }

      const password_product_delete = document.getElementById("password_product_delete").value;
      const id_delete = this.getCurrentDeleteProduct.id;

      const objProductDelete = {
        "id": id_delete,
        "password": password_product_delete
      }

      const buttonDeleteProduct = this.$refs.buttonDeleteProduct;
      buttonDeleteProduct.disabled = true;
      buttonDeleteProduct.innerHTML = "Deletando...";
      const alertResponse = this.alertResponse;

        api.axios.post("/api/products/" + id_delete, objProductDelete).catch(function(error){
          if(error.response.data != undefined){
            buttonDeleteProduct.innerHTML = "Deletar";
          }
          console.log("error", error);
          alertResponse(error.response.data, true);
          buttonDeleteProduct.disabled = false;
        }).then(function(response){
          
          if(response != undefined && response.status == 200){
            buttonDeleteProduct.innerHTML = "Produto deletado com sucesso !";
            window.location.reload();
          } else {
            buttonDeleteProduct.disabled = false;
            buttonDeleteProduct.innerHTML = "Deletar produto";
            
            document.getElementById("password_product_delete").value = "";
          }
        });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageDeleteProduct").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageDeleteProduct").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiDeleteProduct");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("password_product_delete");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>
